import React from 'react'
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18n from "i18next";
const Cardbbss = () => {
    var lang = i18n.language;
    const { t } = useTranslation();
    return (
        <>
            <NavLink to={t('url.bbss')} className='card-link'>
                <div className="card">
                    <img src={`${process.env.PUBLIC_URL  + '/images/' + lang + "/cards/storage.png"}`} alt="Bass storage" />
                    <div className="card-text">
                        <h3>{t('storage.bess-battery-storage-systems')}</h3>
                    </div>
                    <div className="readmore">
                        <NavLink to={t('url.bbss')} exact>{t('storage.product-text-4')}</NavLink>
                    </div>
                </div>
            </NavLink>
            <div className="card-shadow">
                <img src={`${process.env.PUBLIC_URL}/images/cards/shadow.png`} alt="shadow card" />
            </div>
        </>
    )
}

export default Cardbbss